import { Environment } from 'data/Environment'

type Config = {
    environment?: Environment
}

const config: Config = {
    environment: undefined,
}

const setConfig = (newConfig: Config) => {
    for (const prop in newConfig) {
        if (Object.prototype.hasOwnProperty.call(newConfig, prop)) {
            config[prop] = newConfig[prop]
        }
    }
}

const getConfig = (): Config => config

export { getConfig, setConfig }
